import React, { useState } from "react";
import { components } from "react-select";
import Selector from "../dropdown/commonDropdown/Selector";
import RadioButton from "./RadioButton";
import ValidationText from "../../utils/validation/ValidationText";
import ToggleButton from "../common/ToggleButton";
import DropdownSelect from "../dropdown/Dropdown";
import CPDCard from "./CPDCard";
import { Button } from "react-scroll";

const EditDetailsColumn2 = (props) => {

    const [creditName, setCreditName] = useState("");

    const onAddCpdCredits = () => {
        props.cpdCreditsAction["ADD"](creditName);
        setCreditName("");
    }

    return (
        <>
            {/* <div className="text-[#757575] text-[18px]">
                <h2 className="text-[18px] text-[#757575] font-bold mb-2">
                    Entry Topic <span className="text-[#f72b2b]">*</span>
                </h2>
                <Selector
                    options={props.categoryEntry}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={props.handleChangeInDropdown}
                    allowSelectAll={true}
                    value={props.categoryCampaignItem.selectedCategoryEntryIds}
                    drpIdentity="CategoryEntry"
                />

                <div>
                    <ValidationText
                        error={props.validState.error.selectedCategoryEntryIds}
                    />
                </div>
            </div> */}
            <div className="text-[#757575] text-[18px] ">
                <h2 className="font-bold mb-2">
                    Campaign
                </h2>
                <Selector
                    options={props.campaignList}
                    // isMulti
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    // components={{
                    //   Option,
                    // }}
                    onChange={props.handleChangeInDropdown}
                    allowSelectAll={false}
                    value={props.campaignList.find(
                        (item) =>
                            item.value === props.categoryCampaignItem.selectedCampaignId
                    )}
                    drpIdentity="CampaignName"
                />
            </div>
            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">
                    Meta Title
                </h2>
                <input
                    className="w-full"
                    placeholder=""
                    type="text"
                    name="metaTitle"
                    value={props.categoryCampaignItem.metaTitle ? props.categoryCampaignItem.metaTitle : ''}
                    onChange={(event) => props.handleChange(event)}
                />
            </div>
            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">
                    Meta Keyword
                </h2>
                <input
                    className="w-full"
                    placeholder=""
                    type="text"
                    name="metaKeyword"
                    value={props.categoryCampaignItem.metaKeyword ? props.categoryCampaignItem.metaKeyword : ""}
                    onChange={(event) => props.handleChange(event)}
                />
            </div>
            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">
                    Meta Description
                </h2>
                <textarea
                    className="w-full h-[120px]"
                    placeholder=""
                    id="meta_description"
                    name="metaDescription"
                    rows="2"
                    value={props.categoryCampaignItem.metaDescription ? props.categoryCampaignItem.metaDescription : ""}
                    onChange={(event) => props.handleChange(event)}
                />
                <div>

                </div>
            </div>
            <div className="text-[#757575] text-[18px]">
                <h2 className="text-[18px] text-[#757575] font-bold mb-2">
                    Payment Methods <span className="text-[#f72b2b]">*</span>
                </h2>
                <Selector
                    options={props.paymentCategory}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={props.handleChangeInDropdown}
                    allowSelectAll={true}
                    value={props.categoryCampaignItem.selectedPaymentCategoryIds}
                    drpIdentity="PaymentCategory"
                />

                <div>
                    <ValidationText
                        error={props.validState.error.selectedPaymentCategoryIds}
                    />
                </div>
            </div>

            {/* <div className="text-[#757575] text-[18px]">
                <ToggleButton
                    label="Featured"
                    setToggle={props.categoryCampaignItem.isFeatured}
                    onHandleToggle={props.filterByFeatured}
                    index={0}
                    identity="Featured"
                />
            </div> */}
            {/* <div className="text-[#757575] text-[18px]">
                <ToggleButton
                    label="Reminder Email"
                    setToggle={props.categoryCampaignItem.isReminderEmail}
                    onHandleToggle={props.filterByFeatured}
                    index={1}
                    identity="ReminderEmail"
                />
            </div> */}
            <div className="text-[#757575] text-xl">
                Visibility
            </div>
            <div>
                <RadioButton
                    radioLabel="Hidden"
                    name="visibility-radio"
                    id="isHidden"
                    value={props.categoryCampaignItem.isHidden}
                    handleRadioButtons={props.handleRadioButtons}
                    checked={props.categoryCampaignItem.isHidden === true}
                />
            </div>

            <div>
                <RadioButton
                    radioLabel="Private"
                    name="visibility-radio"
                    id="isPrivate"
                    value={props.categoryCampaignItem.isPrivate}
                    handleRadioButtons={props.handleRadioButtons}
                    checked={props.categoryCampaignItem.isPrivate === true}
                />
            </div>
            <div>
                <RadioButton
                    radioLabel="Public"
                    name="visibility-radio"
                    id="isPublic"
                    value={props.categoryCampaignItem.isPublic}
                    handleRadioButtons={props.handleRadioButtons}
                    checked={props.categoryCampaignItem.isPublic === true}
                />
            </div>
            <div className="border border-gray-300 rounded p-4 shadow-sm mb-6">
                <h2 className="font-bold mb-2 text-[#757575] text-[18px] ">CPD CREDITS</h2>
                {/* <label htmlFor="credit" className="block text-[#757575] text-sm font-bold mb-1">
                    CREDIT
                </label> */}
                <div className="flex mb-4 items-center justify-between">
                <input
                    id="credit"
                    type="text"
                    name="Credit"
                    value={creditName}
                    onChange={(e) => setCreditName(e?.target?.value)}
                    className="w-full border border-gray-300 rounded text-sm "
                    placeholder="Enter Credit Name"
                />
                    <button
                        className="bg-transparent hover:bg-blue-500 text-blue-700 flex ml-3 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded text-sm "
                        onClick={ onAddCpdCredits }
                    >
                        ADD
                    </button>
                </div>
                {props?.cpdCreditsList?.map((item, index) => {
                    return <div key={item.eventCPDCreditName + index} className="flex flex-wrap justify-between gap-y-4">
                        <CPDCard
                            id={item.eventCPDCreditName + index}
                            onChange={(value) => props.cpdCreditsAction["ON_CHANGE"](value, index)}
                            item={item}
                            onDelete={() => { props.cpdCreditsAction["DELETE"](index, item.eventCPDCreditId) }}
                        />
                    </div>
                })}
            </div >

            <div className="text-[#757575] text-[18px] ">
                <h2 className="font-bold mb-2">
                    Xero Event Types <span className="text-[#f72b2b]">*</span>
                </h2>
                <DropdownSelect
                    drpIdentity="xeroEventTypes"
                    optionArray={props.xeroEventTypes}
                    setFilterParameters={props.handleChangeInCodesDropdown}
                    value={props.categoryCampaignItem.xeroEventTypeId}
                    onBlur={() => props.validateField("xeroEventTypeId")}
                />
                <div>
                    <ValidationText
                        error={props.validState.error.xeroEventTypeId}
                    />
                </div>
            </div>
            <div className="text-[#757575] text-[18px]">
                <h2 className="font-bold mb-2">
                   Reference
                </h2>
                <input
                    className="w-full"
                    placeholder=""
                    type="text"
                    name="reference"
                    // value={props.categoryCampaignItem.reference ? props.categoryCampaignItem.reference : 'Event'}
                    value={props.categoryCampaignItem.reference}
                    onChange={(event) => props.handleChange(event)}
                />
            </div>
        </>
    )
}
export default EditDetailsColumn2;